import { Fragment } from 'react';
import { cardSrc } from './resultParsers';

// Teenpatti 2.0 (teen6) result. card 6 codes interleaved: Player A = [0,2,4],
// Player B = [1,3,5]. rdesc = "<Winner>#<Suit x6>#<Odd/Even x6>#<Cards x6>#<Under/Over>".
export default function Teen6Result({ detail }) {
  const cards = (detail?.card || '').split(',').map((c) => c.trim()).filter(Boolean);
  const parts = String(detail?.rdesc || '').split('#');

  const winner = parts[0] || detail?.winnat || '';
  const suit = parts[1] || '';
  const oddEven = parts[2] || '';
  const cardsDesc = parts[3] || '';
  const underOver = parts[4] || '';

  // interleaved: Player A = codes[0,2,4], Player B = codes[1,3,5]
  const playerACards = [cards[0], cards[2], cards[4]].filter(Boolean);
  const playerBCards = [cards[1], cards[3], cards[5]].filter(Boolean);
  const isAWinner = winner.includes('Player A');

  const winnerIcon = (
    <div className="casino-result-cards-item">
      <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="winner" />
    </div>
  );

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <h4>Player A</h4>
            {' '}
            <div className="casino-result-cards">
              {isAWinner ? winnerIcon : null}
              {playerACards.map((c, i) => (
                <Fragment key={i}>
                  {' '}
                  <div className="casino-result-cards-item">
                    <img src={cardSrc(c)} alt={c} />
                  </div>
                </Fragment>
              ))}
            </div>
          </div>
          <div className="casino-result-content-diveder"></div>
          <div className="casino-result-content-item text-center">
            <h4>Player B</h4>
            {' '}
            <div className="casino-result-cards">
              {!isAWinner ? winnerIcon : null}
              {playerBCards.map((c, i) => (
                <Fragment key={i}>
                  {' '}
                  <div className="casino-result-cards-item">
                    <img src={cardSrc(c)} alt={c} />
                  </div>
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winner}</div>
          </div>
          {suit && (
            <div className="casino-result-desc-item">
              <div>Suit</div>
              <div>{suit}</div>
            </div>
          )}
          {oddEven && (
            <div className="casino-result-desc-item">
              <div>Odd/Even</div>
              <div>{oddEven}</div>
            </div>
          )}
          {cardsDesc && (
            <div className="casino-result-desc-item">
              <div>Cards</div>
              <div>{cardsDesc}</div>
            </div>
          )}
          {underOver && (
            <div className="casino-result-desc-item">
              <div>Under/Over</div>
              <div>{underOver}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
